import { useParams } from "react-router-dom";
import { ScenariosTab } from "@/components/experience/scenarios-tab";

export function ProjectScenariosPage() {
  const { id } = useParams<{ id: string }>();
  if (!id) return null;
  return <ScenariosTab projectId={id} />;
}
